/* eslint-disable import/prefer-default-export */

export type CompletionPromiseReturn = {
  promise: Promise<void>;
  resolver: (value: void | Promise<void>) => void;
};

/**
 * This function returns a promise that will resolve when the resolver is called.
 */
export function getPromiseAndResolver(): CompletionPromiseReturn {
  let wasCalled = false;
  let resolver: (value: void | Promise<void>) => void = () => {
    wasCalled = true;
  };
  const promise = new Promise<void>(r => {
    if (wasCalled) {
      r();
      return;
    }

    resolver = r;
  });
  return { promise, resolver };
}

export function rxdbLog(message: string, ...args: unknown[]): void {
  // eslint-disable-next-line no-console
  console.log(`%c[RxDB] ${message}`, 'color: #0570eb; font-weight: bold', ...args);
}

export function rxdbError(message: string, ...args: unknown[]): void {
  console.error(`%c[RxDB] ${message}`, 'color: red; font-weight: bold', ...args);
}
